import React from "react";
import { Link } from "react-router-dom";
import "./styles/Footer.css";

export default function Footer() {
  return (
    <footer className="footer" id="contact">
      <div className="footer-content">
        <p>
          © {new Date().getFullYear()} SIARA MARKETING PRIVATE LIMITED.
        </p>
        <p>All rights reserved.</p>
      </div>

      <div className="footer-links">
        <Link to="/terms" className="footer-link">
          Terms & Conditions
        </Link>
        <Link to="/privacy-policy" className="footer-link">
          Privacy Policy
        </Link>
      </div>

      {/* DUNS Registered Seal */}
      <div className="duns-seal">
        <iframe id='Iframe1' src='https://dunsregistered.dnb.com/SealAuthentication.aspx?Cid=1' width='114px' height='97px' frameborder='0' scrolling='no' allowtransparency='true' ></iframe>
      </div>
    </footer>
  );
}